import { render, staticRenderFns } from "./ReportOrdersLabel.vue?vue&type=template&id=71b4bad7&scoped=true&"
import script from "./ReportOrdersLabel.vue?vue&type=script&lang=js&"
export * from "./ReportOrdersLabel.vue?vue&type=script&lang=js&"
import style0 from "./ReportOrdersLabel.vue?vue&type=style&index=0&id=71b4bad7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b4bad7",
  null
  
)

export default component.exports